export default "<ion-app>\n  <!-- (activate)='onActivate($event)' -->\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n";